import { MobileLandingScreen } from './MobileLandingScreen'
import { MobileQuotes } from './MobileQuotes'

export const routes = [
  { path: '/mobile', component: MobileLandingScreen },
  { path: '/mobile/deals', component: MobileQuotes }
]
